__turbopack_context__.v({
  "animateFlag": "csDy_a_animateFlag",
  "flagImage": "csDy_a_flagImage",
  "flagWrapper": "csDy_a_flagWrapper",
  "flutter": "csDy_a_flutter",
  "root": "csDy_a_root",
  "showPoll": "csDy_a_showPoll",
  "wave": "csDy_a_wave",
});
